/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Lexique_To_Install_GatewayInputs */



/**
* | output |
* | --- |
* | "Install gateway" |
*
* @param {Intervention_Plan_Pdf_Lexique_To_Install_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_lexique_to_install_gateway = /** @type {((inputs?: Intervention_Plan_Pdf_Lexique_To_Install_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Lexique_To_Install_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Install gateway")
	return /** @type {LocalizedString} */ ("Installer la box")
});